/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakers: NonNullable<unknown> }} Ccsl_Export_Speaker_OnlyInputs */

const en_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const fr_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const de_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const it_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const ru_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const es_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const zh_cn2_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const ja_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const hi_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

const pt_pt2_ccsl_export_speaker_only = /** @type {(inputs: Ccsl_Export_Speaker_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers}`)
};

/**
* | output |
* | --- |
* | "{speakers}" |
*
* @param {Ccsl_Export_Speaker_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_speaker_only = /** @type {((inputs: Ccsl_Export_Speaker_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Speaker_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_speaker_only(inputs)
	if (locale === "de") return de_ccsl_export_speaker_only(inputs)
	if (locale === "it") return it_ccsl_export_speaker_only(inputs)
	if (locale === "ru") return ru_ccsl_export_speaker_only(inputs)
	if (locale === "es") return es_ccsl_export_speaker_only(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_speaker_only(inputs)
	if (locale === "ja") return ja_ccsl_export_speaker_only(inputs)
	if (locale === "hi") return hi_ccsl_export_speaker_only(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_speaker_only(inputs)
	return en_ccsl_export_speaker_only(inputs)
});